/*
  assets/mad-quote-form.js (Worker C)
  The shared step dialog (Request your quote) on the cart page: open and close (focus trapped, Escape and
  overlay close, focus returns to the opener), one scrolling screen with the submit button in a
  sticky row (reachable on a 375 wide phone without scrolling), validation, ZIP to state with
  a one-tile confirm, ship or pickup (shipping requires the full delivery address, pickup requires
  none of it), the two timeline tiles (standard | expedited, which also set the hidden expedited
  yes | no), the trade tile, and the estimate summary inside the dialog. Submission is in
  mad-quote-submit.js. All DOM lookups are fresh so the code survives Craft's section re-render.
*/
(function () {
  'use strict';
  if (window.MadQuoteForm) return;

  var g = function (id) { return document.getElementById(id); };
  var opener = null;

  /* Clarity events (Seth 2026-10-10): the quote form's steps show in Clarity as events, so recordings can be filtered
     and funnels built there. Nothing happens when Clarity is not running (no consent, preview, theme editor). */
  /* snippets/mad-clarity.liquid holds markers until Clarity has started (window.madClarityEvent): quote_form_open fires
     as the cart loads, before Clarity starts, and was lost (Seth 2026-10-11) */
  function tag(name) { try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent(name); else if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* ignore */ } }

  /* ZIP prefix (first three digits) to state. Specific rows come before the ranges they sit inside. */
  var ZIP = [[55,55,'MA'],[201,201,'VA'],[885,885,'TX'],[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],
    [60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],
    [270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],
    [430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],
    [600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],
    [820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],
    [980,994,'WA'],[995,999,'AK']];
  var STATES = { AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington, DC',
    FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',
    MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',
    NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',
    PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',
    WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming' };

  function stateFromZip(zip) {
    var m = String(zip || '').match(/^(\d{3})/);
    if (!m) return '';
    var n = parseInt(m[1], 10);
    for (var i = 0; i < ZIP.length; i++) if (n >= ZIP[i][0] && n <= ZIP[i][1]) return ZIP[i][2];
    return '';
  }

  function fillStates(select) {
    if (!select || select.options.length > 1) return;
    Object.keys(STATES).sort(function (a, b) { return STATES[a] < STATES[b] ? -1 : 1; }).forEach(function (code) {
      var o = document.createElement('option'); o.value = code; o.textContent = STATES[code]; select.appendChild(o);
    });
  }

  function form() { return g('mad-cq-form'); }
  function config() {
    var el = g('mad-cq-config'), local = {};
    try { local = el ? JSON.parse(el.textContent) : {}; } catch (e) { local = {}; }
    return Object.assign({}, window.MadQuoteConfig || {}, local);
  }
  function modal() { return g('mad-cq-modal'); }
  function isOpen() { var m = modal(); return !!m && m.getAttribute('aria-hidden') === 'false'; }

  /* ── open / close ─────────────────────────────────────────────── */
  function open(fromEl) {
    var m = modal(), f = form();
    if (!m || !f) return;
    opener = fromEl || document.activeElement;
    fillStates(f.querySelector('[data-mad-state]'));
    var success = m.querySelector('[data-mad-cq-success]');
    /* QA Q-04: the estimate that was just sent opens on its confirmation (Send would only make a duplicate);
       a changed estimate opens the form with Send ready (MadQuoteSubmit.reopen resets the "Sent" state). */
    var sentView = false;
    try { sentView = !!(window.MadQuoteSubmit && window.MadQuoteSubmit.reopen && window.MadQuoteSubmit.reopen() === 'sent'); } catch (e) { sentView = false; }
    if (sentView && success) {
      f.hidden = true;
      success.hidden = false;
      m.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mad-modal-open');
      var head = success.querySelector('h3');
      setTimeout(function () { if (head) { head.setAttribute('tabindex', '-1'); head.focus(); } }, 30);
      return;
    }
    if (success) success.hidden = true;
    f.hidden = false;
    fillCart();
    g('mad_cq_submitted_at').value = new Date().toISOString();
    setError('');
    var body = m.querySelector('.mad-dialog__body'); if (body) body.scrollTo(0, 0);
    syncShip(); syncTimeline(); syncEstimate();
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mad-modal-open');
    document.dispatchEvent(new CustomEvent('mad:cq:opened'));
    tag('quote_form_open');
    var first = f.querySelector('input[name="full_name"]');
    setTimeout(function () {
      if (first && !first.value) first.focus();
      verifyContact(f.querySelector('input[name="phone"]'), false);
      verifyContact(f.querySelector('input[name="email"]'), false);
    }, 30);
  }

  /* cart_json, cart_total and item_count: the estimate list through its adapter (plan 5.4) when it has
     doors, otherwise /cart.js as before. Called on open and again right before sending. */
  function fillCart() {
    var get = window.MadQuoteLines && window.MadQuoteLines.quoteCart ? window.MadQuoteLines.quoteCart()
      : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return get.then(function (cart) {
      g('mad_cq_cart_json').value = btoa(unescape(encodeURIComponent(JSON.stringify(cart))));
      g('mad_cq_cart_total').value = ((Number(cart.total_price) || 0) / 100).toFixed(2);
      g('mad_cq_item_count').value = cart.item_count;
      /* Codex re-check: more lines than one quote request can hold (the Zap's 40) is said as the form opens, before
         anything is typed; Send checks again and stops (mad-quote-submit.js) */
      var QL = window.MadQuoteLines, n = cart && Array.isArray(cart.items) ? cart.items.length : 0;
      if (QL && QL.QUOTE_LINE_LIMIT && n > QL.QUOTE_LINE_LIMIT && isOpen()) setError(QL.tooManyText(n, 0));
      return cart;
    }).catch(function () { return null; });
  }

  function close() {
    var m = modal();
    if (!m) return;
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mad-modal-open');
    if (opener && document.contains(opener) && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  /* ── validation (one screen; the status line sits in the sticky row next to Send) ── */
  function setError(text) {
    var el = g('mad_cq_status'); if (!el) return;
    el.textContent = text || '';
  }

  /* Keep the active field in view inside the dialog body. Never use scrollIntoView(center):
     on phones that throws the keyboard and the caret to a random spot. */
  function dialogBody() {
    var m = modal();
    return m ? m.querySelector('.mad-dialog__body') : null;
  }

  function keepInView(el) {
    var body = dialogBody();
    if (!body || !el || typeof el.getBoundingClientRect !== 'function') return;
    var br = body.getBoundingClientRect();
    var er = el.getBoundingClientRect();
    var pad = 20;
    if (er.top < br.top + pad) body.scrollTop -= (br.top + pad - er.top);
    else if (er.bottom > br.bottom - pad) body.scrollTop += (er.bottom - (br.bottom - pad));
  }

  function scrollTo(el) {
    if (!el) return;
    keepInView(el);
    if (typeof el.focus === 'function') el.focus({ preventScroll: true });
  }

  function formFields() {
    var f = form();
    if (!f) return [];
    return Array.prototype.filter.call(f.querySelectorAll('input, select, textarea'), function (el) {
      if (el.disabled || el.type === 'hidden') return false;
      if (el.type === 'checkbox' || el.type === 'radio') return false;
      if (el.closest('[hidden]')) return false;
      return !!(el.offsetParent || el.getClientRects().length);
    });
  }

  function focusNextField(from) {
    var fields = formFields();
    var i = fields.indexOf(from);
    if (i < 0) return;
    var next = fields[i + 1];
    if (!next) {
      var submit = g('mad_cq_submit');
      if (submit) { keepInView(submit); submit.focus({ preventScroll: true }); }
      return;
    }
    keepInView(next);
    next.focus({ preventScroll: true });
  }

  function shipping() { var f = form(); var r = f && f.querySelector('input[name="fulfillment_method"]:checked'); return !r || r.value !== 'pickup'; }

  function digits(s) { return String(s || '').replace(/\D/g, ''); }

  function phoneDigits(raw) {
    var d = digits(raw);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d;
  }

  function phoneOk(raw) {
    var d = phoneDigits(raw);
    if (d.length !== 10) return false;
    if (d.charAt(0) < '2' || d.charAt(3) < '2') return false;
    if (/^(\d)\1{9}$/.test(d)) return false;
    return true;
  }

  function formatPhone(raw) {
    var d = phoneDigits(raw);
    if (d.length !== 10) return String(raw || '').trim();
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }

  function emailOk(raw) {
    var s = String(raw || '').trim();
    if (!s || s.length > 254 || /\s/.test(s)) return false;
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(s);
  }

  function markCheck(el, state, msg) {
    var field = el && el.closest ? el.closest('.mad-field') : null;
    if (!field) return;
    if (!state) {
      field.removeAttribute('data-mad-check');
      field.removeAttribute('data-mad-check-msg');
      return;
    }
    field.setAttribute('data-mad-check', state);
    field.setAttribute('data-mad-check-msg', msg || '');
  }

  /* Shape check only. A live ring or inbox test would mean sending a code, which we do not do here. */
  function verifyContact(el, finalize) {
    if (!el || (el.name !== 'phone' && el.name !== 'email')) return true;
    var raw = String(el.value || '').trim();
    if (!raw) {
      el.setCustomValidity('');
      markCheck(el, finalize ? 'bad' : '', finalize ? (el.getAttribute('data-mad-required-msg') || 'Please fill in this field.') : '');
      return !finalize;
    }
    if (el.name === 'phone') {
      var count = phoneDigits(raw).length;
      var ok = phoneOk(raw);
      if (count === 10) el.value = formatPhone(raw);
      var judged = finalize || count >= 10;
      el.setCustomValidity(!judged || ok ? '' : 'Enter a 10 digit phone number, like (337) 555-0123.');
      markCheck(el, !judged ? '' : (ok ? 'ok' : 'bad'), ok ? 'Phone number looks good' : 'Enter a 10 digit phone number, like (337) 555-0123.');
      return ok || !finalize;
    }
    var okEmail = emailOk(raw);
    el.value = raw;
    var judgedEmail = finalize || raw.indexOf('@') !== -1;
    el.setCustomValidity(!judgedEmail || okEmail ? '' : 'Enter a full email, like name@email.com.');
    markCheck(el, !judgedEmail ? '' : (okEmail ? 'ok' : 'bad'), okEmail ? 'Email looks good' : 'Enter a full email, like name@email.com.');
    return okEmail || !finalize;
  }

  function validate() { var ok = check(); if (!ok) tag('quote_form_error'); return ok; }
  function check() {
    var f = form(); if (!f) return true;
    var phone = f.querySelector('input[name="phone"]');
    var email = f.querySelector('input[name="email"]');
    if (phone && !verifyContact(phone, true)) { setError(phone.validationMessage); scrollTo(phone); return false; }
    if (email && !verifyContact(email, true)) { setError(email.validationMessage); scrollTo(email); return false; }
    var fields = f.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio' || el.closest('[hidden]')) continue;
      el.classList.add('mad-touched');
      /* the address fields carry their own sentence (freight is quoted to the full address) */
      if (el.hasAttribute('required') && !el.value.trim()) { setError(el.getAttribute('data-mad-required-msg') || el.validationMessage || 'Please fill in this field.'); scrollTo(el); el.reportValidity(); return false; }
      if (el.value && !el.checkValidity()) { setError(el.validationMessage || 'Please check this field.'); scrollTo(el); el.reportValidity(); return false; }
    }
    if (shipping()) {
      var confirm = f.querySelector('[data-mad-state-confirm]');
      var box = f.querySelector('[data-mad-state-confirm-box]');
      if (confirm && !confirm.hidden && box && !box.checked) { setError('Tap the tile to confirm the shipping state, or change it above.'); scrollTo(box); return false; }
    }
    if (!f.querySelector('input[name="timeline"]:checked')) { setError('Pick a timeline so we can plan the shop work.'); scrollTo(f.querySelector('input[name="timeline"]')); return false; }
    setError('');
    return true;
  }

  /* ── field behaviour ──────────────────────────────────────────── */
  /* Shipping: the whole delivery address (street, city, ZIP, state) is required and shown. Pickup: hidden, nothing required. */
  function syncShip() {
    var f = form(); if (!f) return;
    var ship = shipping(), box = f.querySelector('[data-mad-ship-fields]');
    if (box) box.hidden = !ship;
    Array.prototype.forEach.call(f.querySelectorAll('[data-mad-ship-required]'), function (el) {
      if (ship) el.setAttribute('required', ''); else el.removeAttribute('required');
    });
    var note = document.querySelector('[data-mad-cq-freight]');
    if (note) note.textContent = ship ? freightSentence() : 'Pickup in Lafayette, no freight';
  }

  /* D8: the typical range for one or two doors; three or more are quoted for the ZIP. Seth 2026-10-13: doors with
     services ship by Curbside LTL Freight, said by name, and no range while prices are hidden (a test; Theme settings >
     Quote funnel > Show prices, window.MadQuoteConfig.showPrices) */
  function showPrices() { return (window.MadQuoteConfig || {}).showPrices === true; }
  function freightSentence() {
    var E = window.MADEstimate, c = window.MadQuoteLines ? window.MadQuoteLines.collect() : null;
    if (E && E.deliveryText) return E.deliveryText({ services: !!(c && c.anyService), prices: showPrices(), doorCount: c ? c.doorCount : null }, window.MAD_PRICE_BOOK || {});
    return E && E.freightText ? E.freightText(c ? c.doorCount : null, window.MAD_PRICE_BOOK || {}) : 'Freight quoted to your ZIP.';
  }

  /* The Expedited timeline tile is the expedited choice: the hidden expedited input follows it (yes | no). */
  function expedited() { var f = form(); var t = f && f.querySelector('input[name="timeline"]:checked'); return !!t && t.value === 'expedited'; }
  function syncTimeline() {
    var f = form(); if (!f) return;
    var hid = f.querySelector('[data-mad-expedited]'); if (hid) hid.value = expedited() ? 'yes' : 'no';
    var date = f.querySelector('input[name="target_date"]'); if (date) date.value = '';
  }

  function syncState(fromZip) {
    var f = form(); if (!f) return;
    var zip = f.querySelector('[data-mad-zip]'), sel = f.querySelector('[data-mad-state]'), tile = f.querySelector('[data-mad-state-confirm]');
    var name = f.querySelector('[data-mad-state-name]'), box = f.querySelector('[data-mad-state-confirm-box]');
    if (fromZip && zip && sel) {
      var code = stateFromZip(zip.value);
      /* Seth 2026-10-10 (fewer clicks): the state read from the ZIP counts as confirmed; the tile shows it and the
         customer can still change it above (unticking the tile asks them to confirm or change it) */
      if (code && sel.value !== code) { sel.value = code; if (box) box.checked = true; }
    }
    if (sel && sel.value) {
      if (name) name.textContent = STATES[sel.value] || sel.value;
      if (tile) tile.hidden = false;
      if (!fromZip && box) box.checked = true; /* the customer chose the state by hand, that is the confirmation */
    } else if (tile) tile.hidden = true;
  }

  function syncEstimate() {
    var m = modal(); if (!m || !window.MadQuoteLines) return;
    var c = window.MadQuoteLines.collect(), money = window.MadQuoteLines.money;
    var set = function (sel, text) { var el = m.querySelector(sel); if (el) el.textContent = text; };
    set('[data-mad-cq-doors]', money(c.doors)); set('[data-mad-cq-services]', money(c.services)); set('[data-mad-cq-estimate-total]', money(c.total));
    /* Trade (Seth, 2026-09-25, answer 7): store credit on the first paid order on the account, then 10% off the
       doors; services and freight at full price. Until the Zap applies it (price book
       zap_supports.trade_discount) the row says the trade pricing is confirmed on the quote. */
    set('[data-mad-cq-trade-amount]', c.tradeDiscount > 0 ? money(-c.tradeDiscount) : 'confirmed on your quote');
    var tradeRow = m.querySelector('[data-mad-cq-trade-row]'); if (tradeRow) tradeRow.hidden = !c.tradeKnown;
    var f = form();
    /* the Standard tile tells the lead time that applies to these doors (D2) */
    var cfg = config(), std = m.querySelector('[data-mad-standard-text]');
    if (std && (cfg.leadTimeShopWork || cfg.leadTimeNoShopWork)) std.textContent = c.anyService ? (cfg.leadTimeShopWork || std.textContent) : ('door only ' + (cfg.leadTimeNoShopWork || ''));
    if (shipping()) { var fr = m.querySelector('[data-mad-cq-freight]'); if (fr) fr.textContent = freightSentence(); }
    var hint = m.querySelector('[data-mad-ship-hint]'); if (hint) hint.textContent = c.anyService ? 'Curbside LTL Freight to your address' : 'Freight to your address';
    var exp = m.querySelector('[data-mad-cq-expedited-line]'), tr = m.querySelector('[data-mad-cq-trade-line]');
    if (exp && f) exp.hidden = !expedited();
    if (tr && f) {
      var known = f.querySelector('[data-mad-trade-known]');
      var box = f.querySelector('[data-mad-trade]');
      tr.hidden = !(known || (box && box.checked));
    }
    var est = m.querySelector('[data-mad-cq-estimate]'); if (est) est.hidden = !c.anyRaw;
    /* "one of one" is said of antiques only (Seth, 2026-09-26): not on a quote of handcrafted doors alone */
    var hold = m.querySelector('[data-mad-cq-hold]'); if (hold) hold.hidden = !c.anyAntique;
  }

  document.addEventListener('change', function (e) {
    var f = form(); if (!f || !f.contains(e.target)) return;
    var t = e.target;
    setError(''); /* the customer is fixing something; drop the stale validation sentence */
    if (t.name === 'fulfillment_method') { syncShip(); return; }
    if (t.hasAttribute('data-mad-state')) { syncState(false); return; }
    if (t.name === 'timeline') { syncTimeline(); syncEstimate(); return; }
    /* trade: hidden "no" first, the checkbox "yes" after it; the last value posted wins */
    if (t.hasAttribute('data-mad-trade')) { var tf = f.querySelector('[data-mad-trade-fields]'); if (tf) tf.hidden = !t.checked; syncEstimate(); return; }
  });
  document.addEventListener('input', function (e) {
    var f = form(); if (!f || !f.contains(e.target)) return;
    setError('');
    if (e.target.name === 'phone' || e.target.name === 'email') verifyContact(e.target, false);
    if (e.target.hasAttribute('data-mad-zip') && /^\d{3}/.test(e.target.value)) syncState(true);
  });

  document.addEventListener('focusout', function (e) {
    var f = form(); if (!f || !f.contains(e.target)) return;
    if (e.target.name === 'phone' || e.target.name === 'email') verifyContact(e.target, true);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('#mad-cq-open, [data-mad-cq-open]');
    if (opener) { open(opener); return; }
    if (e.target.closest('[data-mad-cq-close]')) { close(); return; }
    /* Seth 2026-10-11: the one call in the quote path (snippets/cart-quote-submit.liquid); the link itself dials */
    if (e.target.closest('[data-mad-cq-call]')) tag('quote_call_click');
  });

  /* Escape closes; Enter advances to the next field; Tab stays trapped in the panel. */
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }

    var f = form();
    if (e.key === 'Enter' && f && f.contains(e.target) && !e.shiftKey) {
      var t = e.target;
      if (t && t.tagName === 'TEXTAREA') return;
      if (t && (t.type === 'submit' || t.type === 'button' || (t.closest && t.closest('[data-mad-submit]')))) return;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'SELECT')) {
        e.preventDefault();
        focusNextField(t);
        return;
      }
    }

    if (e.key !== 'Tab') return;
    var panel = modal().querySelector('.mad-dialog__panel');
    var items = Array.prototype.filter.call(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.type !== 'hidden' && !el.closest('[hidden]') && el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* When a field gains focus (tap or autofill), nudge it into view without a hard jump. */
  document.addEventListener('focusin', function (e) {
    if (!isOpen()) return;
    var f = form();
    if (!f || !f.contains(e.target)) return;
    if (!(e.target.matches && e.target.matches('input, select, textarea'))) return;
    requestAnimationFrame(function () { keepInView(e.target); });
  });

  document.addEventListener('mad:quote:updated', function () { if (isOpen()) syncEstimate(); });

  /* dvh fallback for older phone browsers. Re-fit around the focused field when the keyboard opens. */
  if (!window.CSS || !CSS.supports || !CSS.supports('height', '100dvh')) {
    var fix = function () {
      var m = modal();
      if (!m || !window.visualViewport || !isOpen()) return;
      m.style.height = window.visualViewport.height + 'px';
      var active = document.activeElement;
      var f = form();
      if (active && f && f.contains(active)) keepInView(active);
    };
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', fix); fix(); }
  } else if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (!isOpen()) return;
      var active = document.activeElement;
      var f = form();
      if (active && f && f.contains(active)) keepInView(active);
    });
  }

  /* Request your quote on the form's added screen (Seth 2026-10-10, fewer clicks; the price sheet's too until 2026-10-12) links to
     /cart#request-quote: the form opens once the estimate has drawn its button. The hash is dropped first, so a
     refresh or Back does not open it again. */
  function openFromHash() {
    if (!location.hash || location.hash !== '#request-quote') return;
    try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) { /* ignore */ }
    var tries = 0;
    (function wait() {
      var btns = document.querySelectorAll('[data-mad-estimate-list] [data-mad-cq-open], #mad-cq-open');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].offsetParent !== null && !btns[i].disabled && form()) { tag('quote_form_from_added'); open(btns[i]); return; }
      }
      if (++tries < 50) setTimeout(wait, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash); else openFromHash();
  /* Release B: a /cart line priced with "Price additional services" moves to the estimate on the cart page itself; its
     added screen's Request your quote only changes the hash there */
  window.addEventListener('hashchange', openFromHash);

  window.MadQuoteForm = { open: open, close: close, isOpen: isOpen, validate: validate, validateStep: validate, stateFromZip: stateFromZip, STATES: STATES, setError: setError, shipping: shipping, expedited: expedited, syncEstimate: syncEstimate, fillCart: fillCart };
})();
